import { render, staticRenderFns } from "./User-delete.vue?vue&type=template&id=af39f48e"
import script from "./User-delete.vue?vue&type=script&lang=js"
export * from "./User-delete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports